import {Injectable} from '@angular/core';
import {KeycloakService} from 'keycloak-angular';
import {Role} from '../../clm/types/role.enum';
import {includesAnyValueInList} from "../util/Util";

@Injectable({
  providedIn: 'root'
})
export class UserAuthorisationService {
  userRoles: string[];

  constructor(private keyCloakService: KeycloakService) {
    this.userRoles = keyCloakService.getUserRoles();
  }

  hasRoleAdmin(): boolean {
    return this.userRoles.includes(Role.GreydomAdmin);
  }

  hasRoleProvider(): boolean {
    return this.userRoles.includes(Role.Provider);
  }

  hasRoleClaimsManager(): boolean {
    return this.userRoles.includes(Role.ClaimsManager);
  }

  hasRoleClaimsTeamLeader(): boolean {
    return this.userRoles.includes(Role.ClaimsTeamLeader);
  }

  hasRoleClaimsAssessor(): boolean {
    return this.userRoles.includes(Role.ClaimsAssessor);
  }

  hasRoleEnterpriseManager(): boolean {
    return this.userRoles.includes(Role.EnterpriseManager);
  }

  hasRoleEnterpriseTeamLeader(): boolean {
    return this.userRoles.includes(Role.EnterpriseTeamLeader);
  }

  hasRoleOperationsManager(): boolean {
    return this.userRoles.includes(Role.OperationsManager);
  }

  hasRoleFinancialManager(): boolean {
    return this.userRoles.includes(Role.FinancialManager);
  }

  hasRoleFinancialTeamLeader(): boolean {
    return this.userRoles.includes(Role.FinancialTeamLeader);
  }

  hasRolePreAuthorisationManager(): boolean {
    return this.userRoles.includes(Role.PreAuthorisationManager);
  }

  hasRolePreAuthorisationTeamLeader(): boolean {
    return this.userRoles.includes(Role.PreAuthorisationTeamLeader);
  }

  hasRoleToSubmitAndReviewTransactions(): boolean {
    return this.hasRoleClaimsAssessor() || this.hasRoleProvider();
  }

  hasRoleTransactionTeamLeader(): boolean {
    return this.hasRoleClaimsTeamLeader() || this.hasRolePreAuthorisationTeamLeader();
  }

  hasRoleClaimReverser(): boolean {
    return this.userRoles.includes(Role.ClaimReverser);
  }

  hasOnBoardingManager(): boolean {
    return this.userRoles.includes(Role.OnBoardingManager);
  }

  hasOnBoardingTeamLeader(): boolean {
    return this.userRoles.includes(Role.OnBoardingTeamLeader);
  }
  hasOnBoardingQC(): boolean {
    return this.userRoles.includes(Role.OnBoardingQC);
  }

  hasBrokerRole(): boolean {
    return this.userRoles.includes(Role.Broker);
  }

  hasRoleBrokerUserManager(): boolean {
    return this.userRoles.includes(Role.BrokerUserManager);
  }

  hasRoleProviderUserManager(): boolean {
    return this.userRoles.includes(Role.ProviderUserManager);
  }

  hasRoleInternalUserManager(): boolean {
    return this.userRoles.includes(Role.UserManager);
  }

  hasRoleExternalUserManager(): boolean {
    return includesAnyValueInList(
      this.userRoles, [
        Role.BrokerUserManager,
        Role.ProviderUserManager
      ]);
  }

  hasUserAnyManagementRole(): boolean {
    return includesAnyValueInList(
      this.userRoles, [
        Role.UserManager,
        Role.BrokerUserManager,
        Role.ProviderUserManager
      ]);
  }
}
